import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ZoomMax",
  "use": "icon-ZoomMax-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ZoomMax\">\r\n    <defs>\r\n        <style type=\"text/css\"></style>\r\n    </defs>\r\n    <path d=\"M960 960H640v64h364c11 0 20-9 20-20V640h-64v320zM1004 0H640v64h320v320h64V20c0-11-9-20-20-20zM64 640H0v364c0 11 9 20 20 20h364v-64H64V640zM0 20v364h64V64h320V0H20C9 0 0 9 0 20z\" p-id=\"2742\" fill=\"#eeeeee\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol